import { gql } from '@apollo/client';

export const GET_PRE_USER_COMPANY = gql`
  query GetPreUserCompany($ownerEmail: String!) {
    preUserCompany(ownerEmail: $ownerEmail) {
      id
      companyId
      companyName
      ownerEmail
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_PRE_USER_COMPANY = gql`
  mutation DeletePreUserCompany($id: ID!) {
    deletePreUserCompany(id: $id)
  }
`;

export const CREATE_PRE_USER_COMPANY = gql`
  mutation CreatePreUserCompany($input: CreatePreUserCompanyInput!) {
    createPreUserCompany(input: $input) {
      id
      companyId
      companyName
      ownerEmail
      createdAt
      updatedAt
    }
  }
`;
